import { logger } from '@logger'
import { PANEL_IDS } from '@constants/bettingConstants'
import { tryEmitPanel } from '@core/betting/classicBettingOrchestrator'
import { freebetTryEmit } from '@core/betting/freebetBettingOrchestrator'
import {
  armSubmissionWindow,
  disarmSubmissionWindow,
  msUntilSubmission,
} from '@core/betting/betSubmissionWindow'

/**
 * The clock behind deferred betting. `socketListeners` arms this on every
 * ACCEPT_BET tick and disarms it on every other phase; when it fires it hands
 * each orchestrator its cue to send whatever the player has pending.
 *
 * It is the ONLY scheduled submission path — the betting hooks also call their
 * orchestrator's `tryEmit` on press, but that no-ops until this window is due,
 * so a press inside the final seconds still goes out immediately while an earlier
 * press waits here.
 */
const MODULE = 'Bet Submission'

let timerId = null

const clearTimer = () => {
  if (timerId == null) return
  clearTimeout(timerId)
  timerId = null
}

// Send every pending (frontend-only) bet. Each orchestrator's tryEmit re-checks
// its own preconditions, so panels with nothing pending simply no-op.
const submitPendingBets = () => {
  timerId = null
  console.log('BETDEBUG-6: submission timer fired — submitting any pending bets now', {
    now: Date.now(),
  })
  logger.info(MODULE, 'Submitting pending bets')
  PANEL_IDS.forEach((panel) => {
    tryEmitPanel(panel)
    freebetTryEmit(panel)
  })
}

/**
 * Open the betting window and schedule the submission for LEAD_MS before it
 * closes. Fires straight away when the window is already inside that lead time
 * (a short round, or a tick that reached us late).
 *
 * @param {{ acceptBetEndTime?: number, delay?: number }} data the ACCEPT_BET tick
 */
export const armBetSubmission = (data) => {
  clearTimer()
  armSubmissionWindow(data)

  const wait = msUntilSubmission()
  console.log('BETDEBUG-5: submission timer decision', { data, wait })
  if (wait == null) {
    console.log('BETDEBUG-5-FAIL: no window resolved, nothing scheduled — bets will never auto-send this round', { data })
    return // no window — nothing to schedule
  }
  if (wait <= 0) {
    console.log('BETDEBUG-5: window already due, submitting immediately (no timer needed)')
    submitPendingBets()
    return
  }
  logger.info(MODULE, 'Submission scheduled', { inMs: wait })
  timerId = setTimeout(submitPendingBets, wait)
}

// Close the window and drop any armed timer — betting is over for this round.
export const disarmBetSubmission = () => {
  clearTimer()
  disarmSubmissionWindow()
}
